import API from "../config/api.js";

export const RoleService = {

    getRoleList(search, page=1) {
        return API.get(`api/role/list/se=${search}?page=${page}`);
    },

    getRoleInfo(name) {
      return API.get(`api/role/info/${name}`);
  },

    getPermissionList() {
      return API.get(`api/role/permission/list`);
    },

  
    createRole(data) {
      return API.post(`api/role/create`,data);
    },

    editRole(data) {
      return API.post(`api/role/update`,data);
    },



  
};